import script from "./NewsPageStoryNatureSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageStoryNatureSelector.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageStoryNatureSelector.vue?vue&type=style&index=0&id=278daac6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-278daac6"]])

export default __exports__